import { Button, Dialog, DialogActions, DialogContent, Grid, IconButton, Typography } from '@mui/material'
import React from 'react'
import { PtrnColors, PtrnIcons } from '../..';
import { PtrnIcon } from '../../../..';
import { PtrnBasicDialogProps } from './PtrnBasicDialogType';

const PtrnBasicDialog = ({
    titulo,
    shortMessage,
    open,
    setOpen,
    icon = PtrnIcons.info,
    cerrarText,
    onCerrar,
    color = PtrnColors.primary
}: PtrnBasicDialogProps) => {
    //Cerrar el dialog y setear los icons
    const handleClose = () => {
        setOpen(false);
        if (onCerrar) {
            onCerrar();
        }
    };
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll={'paper'}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            fullWidth={true}
            PaperProps={{
                sx: {
                    width: "37%", // 👈 controla el ancho en %
                    maxWidth: "none", // para que no limite a los tamaños por defecto
                },
            }}
        >
            <Grid container justifyContent="center" sx={{ mt: 2 }}>
                <PtrnIcon sx={{ fontSize: 80 }} color={color} icon={icon}></PtrnIcon>
            </Grid>
            <DialogContent style={{ padding: '10px' }}>
                <Typography variant='h3' textAlign={'center'} paddingBottom={1}>
                    {titulo}
                </Typography>
                <Typography variant='h5' textAlign={'center'}>
                    {shortMessage}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }} style={{ paddingBottom: '15px' }}>
                <Button onClick={handleClose} color={color} variant='contained'>
                    {cerrarText || 'Cerrar'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default PtrnBasicDialog